<template>
  <div id="home" class="n4-inicio" ref="raiz">
    <!-- Mismo orden y mismos interruptores que la portada de siempre (panel: Inicio) -->
    <N4Portada />
    <N4Notario />
    <N4Servicios />
    <N4Blog />
    <N4Llamada />
    <N4Testimonios />
    <N4Galeria />
    <N2Faq />
    <N2Contacto />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAparicion } from '../../composables/useNotaria2'
import N4Portada from './N4Portada.vue'
import N4Notario from './N4Notario.vue'
import N4Servicios from './N4Servicios.vue'
import N4Blog from './N4Blog.vue'
import N4Llamada from './N4Llamada.vue'
import N4Testimonios from './N4Testimonios.vue'
import N4Galeria from './N4Galeria.vue'
import N2Faq from '../notaria2/N2Faq.vue'
import N2Contacto from '../notaria2/N2Contacto.vue'

const raiz = ref(null)
useAparicion(raiz)
</script>
